export default "__VITE_ASSET__8fef980e__"